import { useFragment } from "@apollo/client";
import {
    TripBuilderDraftQuoteFragment,
    TripBuilderDraftQuoteFragmentDoc,
} from "../../../../generated/graphql";

export const useDraftQuoteFragment = (draftId?: string | null) => {
    const quoteFragment = useFragment({
        fragment: TripBuilderDraftQuoteFragmentDoc,
        fragmentName: "TripBuilderDraftQuote",
        from: {
            __typename: "DraftOrder",
            id: draftId,
        },
    });

    const draftQuote: TripBuilderDraftQuoteFragment | null =
        Object.keys(quoteFragment.data).length === 0
            ? null
            : quoteFragment.data;

    return draftQuote;
};
